// src/hooks/useAuth.js
// STATUS: stable | UPDATED: 2026-08-28
// LOG:
//   2026-08-28  Now reads the shared AuthContext instead of holding its own
//               state. See src/context/AuthProvider.jsx for why. The shape it
//               returns is unchanged apart from two additions, refreshProfile
//               and profileMissing, so no existing call site needed touching.
//   2026-08-02  Header standardized; Phase 1 checkpoint committed (e765830).
// React hook that exposes the current authenticated user, profile, and loading
// state, plus refreshProfile() for anything that writes to the users row.

import { useContext } from 'react'
import { AuthContext } from '../context/AuthProvider.jsx'

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider>. It is mounted in main.jsx.')
  }
  return ctx
}
